import './_index.scss';
import 'mdn-polyfills/Array.prototype.forEach';
import 'mdn-polyfills/NodeList.prototype.forEach';
import $ from 'jquery';
import Rellax from 'rellax';
import 'objectFitPolyfill';
import 'foundation-sites/js/foundation';
import './layout/partials/menu-drilldown';
import './layout/components/photo-gallery';

import './assets/images/fpo-logo.svg';
import './layout/courses/courses';
import externalLinks from './external-links';
import calculator from './calculators/_index';

let glossaryContentLoaded = false;

calculator.init();

$('body').on('click', 'a:not("#external-link-modal a")', externalModalLink);

if (document.querySelector('.rellax')) {
    new Rellax('.rellax');
}

$(document).foundation();

$(document).ready(()=>{
    $('a[href="#modal_glossary"]').each((i, val) => {
        $(val).attr('data-open', 'modal_glossary');
    });
    $('a[href="#modal_calculator"]').each((i, val) => {
        $(val).attr('data-open', 'modal_calculator');
    });
    $('a[href="#modal_standards"]').each((i, val) => {
        $(val).attr('data-open', 'modal_standards');
    });

    $('body')
        .on('change', 'select[name="search-grade"]', standardSearchChange)
        .on('submit', 'form.search-by-standard', submitSearchByStandard)
        .on('open.zf.reveal', '#modal_glossary', handleGlossaryOpen);

    $('select[name="search-grade"]').each((i, val) => {
        standardSearchChange(null, val);
    });

});



//////////

function standardSearchChange(event, target) {
    var $select = event ? $(event.currentTarget) : $(target);
    var $form = $($select.parents('form')[0]);
    var $standards = $form.find('select[name="search-standard"]');
    var $grades = $form.find('select[name="search-grade"]');
    var $grade_options = $grades.find('option');
    var value = $select.val();

    $standards.val('');

    if(!value || (value === '')) {
        $standards.prop('disabled', true);
    }else {
        $standards.prop('disabled', false);
        $standards.find('option').hide();
        $standards.find('option[data-grade="'+value+'"]').show();
    }

    $grade_options.each((i, element)=> {
        var $gradeOption = $(element);
        var value = $gradeOption.attr('value');
        if(!value) {
            return;
        }
        if($standards.find('option[data-grade="' + value + '"]').length === 0) {
            $gradeOption.remove();
        }
    });

    $grade_options = $grades.find('option');

    if($grade_options.length <= 1) {
        $('#search-dropdown-wrap').find('.search-by-standard, .divider-text').hide();
        $('.sidebar').find('.search-by-standard, .divider-text').hide();
    }
}

function submitSearchByStandard( event ) {
    event.preventDefault();
    var $form = $(event.currentTarget);
    var $standards = $form.find('select[name="search-standard"]');
    var value = $standards.val();

    if(!value) {
        $form.find('.search-standard-error').show();
        return;
    }

    $form.find('.search-standard-error').hide();
    document.location = value;
}

function externalModalLink(event) {

    if(!externalLinks.isExternalLink(event.target)) {
        return;
    }

    event.preventDefault();
    externalLinks.openExternalLinkModal(event.target.getAttribute('href'));
}

function handleGlossaryOpen() {
    if(glossaryContentLoaded) {
        return;
    }

    $.post(
        window.ajaxurl,
        { action: 'glossary' },
        function(response) {
            glossaryContentLoaded = true;
            $('#modal_glossary_content').html(response);
        }
        // function() {
        //     console.info('error getting glossary', arguments);
        // }
    );
}


// WEBPACK FOOTER //
// ./src/_index.js